import type { StartTotpEnrollmentRequestDto } from "../generated/schema";
import { useApiMutation } from "./use-api-mutation";

export function useStartTotpEnrollment() {
  return useApiMutation("post", "/auth/mfa/totp/setup", {
    notify: false,
    mapVariables: (body: StartTotpEnrollmentRequestDto) => ({ body }),
  });
}
